import { useMutation } from '@tanstack/react-query';
import {
  invalidateWaitlistEntries,
  invalidateWaitlistEntry,
  removeCancellationWaitlistEntry,
} from '../../services/cancellation-waitlist';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: (message: string) => void | Promise<void>;
}

function useRemoveWaitlistMember({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: (waitlistEntryId: string) =>
      removeCancellationWaitlistEntry(waitlistEntryId),
    onSuccess: async (_data, waitlistEntryId) => {
      await invalidateWaitlistEntries();
      await invalidateWaitlistEntry(waitlistEntryId);
      await onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error.message || 'Failed to remove waitlist member');
    },
  });
}

export default useRemoveWaitlistMember;
